import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { removeTodo } from "../asyncActions/removeTodos";
import { ReactComponent as CalendarIcon } from "./static/calendar.svg";
import { ReactComponent as DublicateIcon } from "./static/dyblicateIcon.svg";
import { ReactComponent as RemoveIcon } from "./static/removeIcon.svg";
import './ContextMenuTask.css';
import { modalWindowContext } from "../Context/modalWindowContext";
import '../DropDownMenu/SelectTaskMenu/index.css';
import { editTodo } from "../asyncActions/editTodos";
import InpuTimeToTask from "../UIcomponents/InputTimeToTask/InputTimeToTask";
import { copyTodo } from "../asyncActions/copyTodo";
import { changeOnContextState } from "../store/contextMenuTaskReducer";
import { useChangeFromContextMenu } from "../customHooks/useChangeFromContextMenu";
import { useConnectionHubContext } from "../Context/connectionHubContext";
import ModalWindowSaveChanges from "../ModalWindow/ModalWindowSaveChanges";
import CustomList from "../UIcomponents/Lists/CustomList";
import differenceOfObjects from "../utils/getDifferenceOfObjects";
import getDateObject from "../utils/getDateObject";
import TaskCalendar from "../UIcomponents/Calendar/Base/Calendar";
import { addTask } from "../asyncActions/TaskActions/addTask";
import { getTodos } from "../asyncActions/getTodosToday";
import { useLocation } from "react-router-dom";
import { useOutsideClick } from "../customHooks/useOutsideClick";


const ContextMenuTask = ({ contextData, contextPosition, task, scrolledY, dateFromCalendarPage, closeContext, onContextStateToTask, fromToday, fromIncoming, fromRemoved, dyblicateTaskToday }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const dateToday = new Date();
  const [taskData, setTaskData] = useState(task);
  const initialTaskData =  task;
  const [modal, setModal] = useState(false);
  const [currentDate] = useState(taskData.date);
  const [targetOfAction, setTargetOfAction] = useState(0);
  const [dateChanged, setDateChanged] = useState(false);
  const [isDeleteTask, setIsDeleteTask] = useState(false);
  const connectionHub = useConnectionHubContext();
  const [hoursToTask, setHoursToTask] = useState(task ? task.hours : '');
  const [minutesToTask, setMinutesToTask] = useState(task ? task.minutes : '');
  const [isActiveCalendar, setIsActiveCalendar] = useState(false);
  const [isActiveTomorrow, setIsActiveTomorrow] = useState(false);
  const [isActiveToday, setIsActiveToday] = useState(false);
  const [isActiveNoDate, setIsActiveNoDate] = useState(false);
  const [currentPriority, setCurrentPriority] = useState(task ? task.priority : null);
  const refChangeToClose = useRef();
  const refCalendar = useRef();
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight + scrolledY;
  const menuAxisX = 239;
  const menuAxisY = 331;
  const arrList = [{id: 'onlyOne', description: 'Только эту задачу'},
    {id: 'thisAndNext', description: 'Эту и последующие задачи'},
    {id: 'All', description: 'Все задачи', isHidden: dateChanged}
  ]
  const updateTaskList = () => {
    connectionHub.updateHub.invoke("Send", localStorage.getItem('userID'))
      .catch(err => console.error(err));
  }
  
  useChangeFromContextMenu(refChangeToClose, () => checkChangedValues(), onContextStateToTask, isActiveCalendar,)
  useOutsideClick(refCalendar, () =>  setIsActiveCalendar(false), isActiveCalendar)


  const todayDiv = <div className="btns-block__tomorrow"
  style={isActiveToday ? { fontWeight: 700 } : null}
  onClick={() => moveToday()}>
  <p>Сегодня</p>
  </div>;

  const tomorrowDiv = <div className="btns-block__no-date"
   style={isActiveTomorrow ? { fontWeight: 700 } : null}
  onClick={() => moveTomorrow()}>
  <p>Завтра</p>
  </div>;
  const nodateDiv = <div className="btns-block__no-date"
  style={isActiveNoDate ? { fontWeight: 700 } : null}
  onClick={() => noData()}>
  <p>Без срока</p>
  </div>;

const moveTomorrow = () => {
  let data;
  if (isActiveTomorrow) {
    setIsActiveTomorrow(false)
    data = currentDate;
  } else {
    setIsActiveTomorrow(true);
    setIsActiveToday(false);
    setIsActiveNoDate(false);
    data = new Date(dateToday.setDate(dateToday.getDate() + 1)).toLocaleDateString()
  }
  setTaskData({
    ...taskData,
    isOpened: taskData.isOpened ?? false,
    date: data
  })
}

const moveToday = () => {
  let data;
  if (isActiveToday) {
    setIsActiveToday(false)
    data = currentDate
  } else {
    setIsActiveToday(true);
    setIsActiveNoDate(false);
    setIsActiveTomorrow(false);
    data = new Date (dateToday.setDate(dateToday.getDate())).toLocaleDateString()
  }
  setTaskData({
    ...taskData,
    date: data
  })
}

const noData = () => {
  let data;
  if (isActiveNoDate) {
    setIsActiveNoDate(false)
    data = currentDate;
  } else {
    setIsActiveNoDate(true)
    setIsActiveTomorrow(false)
    setIsActiveToday(false);
    data = ''
  }
  setTaskData({
    ...taskData,
    date: data
  })
}

  useEffect(() => {
    if (isDeleteTask) {
      setModal(true)
    }
  }, [isDeleteTask])

  const calculatePositionX = () => {
    if ((windowWidth - contextPosition.x_axis) < menuAxisX) {
      return `${windowWidth - (menuAxisX)}px`
    } else {
      return `${contextPosition.x_axis}px`
    }

  }

  const calculatePositionY = () => {
    if ((windowHeight - contextPosition.y_axis) < menuAxisY) {
      return `${windowHeight - (menuAxisY)}px`
    } else {
      return `${contextPosition.y_axis}px`
    }
  }
  
  const handleChangePriority = (value) => {
    setCurrentPriority(value)
    setTaskData({
      ...taskData,
      priority: value
    })
  }

  

  const handleUpdateDateFromCalendar = (payload) => {
    setTaskData({
      ...taskData,
      date: payload.toLocaleDateString()
    })
  }

  

  const handleUpdateHours = (payload) => {
    setHoursToTask(payload.timeToTaskHours)
  }

  const handleUpdateMinutes = (payload) => {
    setMinutesToTask(payload.timeToTaskMinutes)
  }

  const handleFocusDrop = (hoursToTask, minutesToTask) => {
    setTaskData({
      ...taskData,
      hours: hoursToTask === '' ? 0 : hoursToTask,
      minutes: minutesToTask === '' ? 0 : minutesToTask
    })
  }

  const handleCopyTask = () => {
    dispatch(addTask({payload: {
      ...taskData,
      title: `Копия - ${taskData.title}`,
      date: dateToday.toLocaleDateString()
    }, getListVariantTask: getTodos()}))
  }

  const removeHandler = () => {
    dispatch(removeTodo({ id: contextData.taskId, targetOfAction: targetOfAction, dateFromCalendarPage: dateFromCalendarPage }))
      .then(() => {updateTaskList()
        closeContext(contextData.taskId)})
  }

  const updateHandler = () => {
    dispatch(editTodo({ ...taskData, updatePageCalendar: dateFromCalendarPage, targetOfAction, pageSize: contextData.pageIndex * 10, pageIndex: 1 }))
      .then(() => {
        updateTaskList()
      })
  }

  const checkChangedValues = () => {
    const differences = differenceOfObjects({originalObj: initialTaskData, mutableObj: taskData, returnAnswer: 'object'});
    if (task.isRepit) {
      if (Object.keys(differences).length > 0) {
        if (Object.hasOwn(differences, 'date')) {
          setDateChanged(true)
        } else {
          setDateChanged(false)
        }
        setTimeout(() => {
          setModal(true)
        }, 50);
      } else {
        dispatch(changeOnContextState({ contextIsOpen: false, contextTaskId: contextData.taskId }))
      }
    } else {
      if (Object.keys(differences).length > 0) {
        updateHandler()
      }
      dispatch(changeOnContextState({ contextIsOpen: false, contextTaskId: contextData.taskId }))
    }
  }

  const closeWarning = () => {
    setModal(false)
    dispatch(changeOnContextState({ contextIsOpen: false, contextTaskId: contextData.taskId }))
  }

  const changeAction = () => {
    setModal(false)
    dispatch(changeOnContextState({ contextIsOpen: false, contextTaskId: contextData.taskId }))
    if (isDeleteTask) {
      removeHandler()
    } else {
      updateHandler()
    }
  }

  const modalData = {
    data: {
        title: `${location.pathname === '/automation' ? isDeleteTask ? 'Удалить шаблон' : 'Измененить шаблон': isDeleteTask ? 'Удаление' : 'Изменение '} повторяющейся задачи`,
        description: location.pathname !== '/automation' ? <CustomList defaultCheck={targetOfAction} onChangeFunc={(index) => setTargetOfAction(index)} listVariant="radio" list={arrList}/> : 
        isDeleteTask ? <p style={{lineHeight: 1.5}}>Больше никаких новых задач по этому шаблону. <br /> Выполненные никуда не денутся - останутся в списке</p> : 
        <p style={{lineHeight: 1.5}}>Будущие задачи подстроятся под новые параметры. <br />Выполненные трогать не будем.</p>,
        buttons: {
            btnAccept: {
                title: `${isDeleteTask ? 'Удалить' : 'Изменить'}`,
                onClickFunc: changeAction
            },
            btnReject: {
                title: 'Отмена',
                onClickFunc: closeWarning
            }
        }
    }
  }
  
  const dateСomparison = () => {
    if (currentDate === '') {
      return <>
        {todayDiv}
        <span className="btns-block__separator" />
        {tomorrowDiv}
      </>
    } else {
      const receivedDate = getDateObject({dateString: currentDate});
      let date1 = dateToday.setHours(0,0,0,0)
      let date2 =  receivedDate.setHours(0,0,0,0)
      if (date1 > date2) {
        return <>
          {todayDiv}
          <span className="btns-block__separator" />
          {tomorrowDiv}
        </>
      } else if (date1 < date2) {
        return <>
          {todayDiv}
          <span className="btns-block__separator" />
          {nodateDiv}
        </>
      } else {
        return <>
          {tomorrowDiv}
          <span className="btns-block__separator" />
          {nodateDiv}
        </>
      }
    }
  }
  
  return (
    <div ref={refChangeToClose}>
      <modalWindowContext.Provider value={[modal, setModal]}>
        <ModalWindowSaveChanges modalData={modalData} />
      </modalWindowContext.Provider>
      <nav className="contextMenu"
        style={{
          position: 'absolute',
          top: calculatePositionY(),
          left: calculatePositionX()
        }}
        onClick={(e) => e.stopPropagation()}
        >
        <ul className="contextMenu__first-list">
          <li className="contextMenu__first-item">
              {
                isActiveCalendar && 
                <div ref={refCalendar} style={{position: 'absolute', backgroundColor: '#fff', borderRadius: '12px', padding: '15px', zIndex: '99', boxShadow: '0px 0px 25px 0px rgba(35, 35, 96, 0.15)'}}>
                  <TaskCalendar 
                    onCloseCalendar={setIsActiveCalendar}
                    datePayload={getDateObject({dateString: taskData.date})}
                    isPreviosDateAllow={false}
                    onSelectDay={handleUpdateDateFromCalendar}
                  />
                </div>
              }
              {/* <DDSelectDate active={isActiveCalendar}
                calendarPosition={windowWidth > 576 ? { top: '-18px', left: '50px' } : { top: '50%', left: '50%', transform: 'translate(-72%, 0%' }}
                setActive={setIsActiveCalendar}
                datePayload={new Date()}
                updateDataDate={handleUpdateDateFromCalendar}
                typeOfCalendar={1} /> */}
            {/* </div> */}
            <p className="contextMenu__first-item__description">Срок выполнения</p>
            <div className="contextMenu__first-item__btns-block">
              <div className="btns-block__calendar-icon" style={taskData.date !== currentDate ? { fill: '#FFF', backgroundColor: '#5932EA' } : null} onClick={() => setIsActiveCalendar(!isActiveCalendar)}>
                <CalendarIcon></CalendarIcon>
              </div>
              {
                dateСomparison()
              }
            </div>

          </li>
          <li className="contextMenu__first-item">
            <p className="contextMenu__first-item__description">Приоритет</p>
            <div className="contextMenu__first-item__priority-container">
              <ul className="contextMenu__first__priority-list" >
                <li>
                  <span id='0'
                    className={currentPriority === 0 ? "contextMenu__first__priority-list__item current-priority item-1" :
                      "contextMenu__first__priority-list__item item-1"}
                    onClick={(e) => handleChangePriority(0)}
                  >
                    <p className="priority-list__item-description">Высокий</p>
                  </span>
                </li>
                <li>
                  <span id='1'
                    className={currentPriority === 1 ? "contextMenu__first__priority-list__item current-priority item-2" :
                      "contextMenu__first__priority-list__item item-2"}
                    onClick={() => handleChangePriority(1)}
                  >
                    <p className="priority-list__item-description">Средний</p>
                  </span>
                </li>
                <li>
                  <span id='2'
                    className={currentPriority === 2 ? "contextMenu__first__priority-list__item current-priority item-3" :
                      "contextMenu__first__priority-list__item item-3"}
                    onClick={() => handleChangePriority(2)}
                  >
                    <p className="priority-list__item-description">Низкий</p>
                  </span>
                </li>
                <li>
                  <span id='3'
                    className={currentPriority === 3 ? "contextMenu__first__priority-list__item current-priority item-4" :
                      "contextMenu__first__priority-list__item item-4"}
                    onClick={() => handleChangePriority(3)}
                  >
                    <p className="priority-list__item-description">Без приоритета</p>
                  </span>
                </li>
              </ul>
            </div>
          </li>
          <li className="contextMenu__first-item">
            <p style={{ marginBottom: '20px' }} className="contextMenu__first-item__description">Время на задачу</p>
            <InpuTimeToTask updateDataTimeToTaskHours={handleUpdateHours}
              updateDataTimeToTaskMinutes={handleUpdateMinutes}
              timeToTaskHours={hoursToTask}
              timeToTaskMinutes={minutesToTask}
              submitChangeContext={handleFocusDrop} />
          </li>
          <ul className="contextMenu__second-list">
            {
              !task.isRepit && 
              <li className="contextMenu__second-item"
                style={fromRemoved && { cursor: 'default', pointerEvents: 'none', color: '#A4A8B1' }}
                onClick={() => (dyblicateTaskToday ? handleCopyTask() : dispatch(copyTodo({ id: contextData.taskId, dateFromCalendarPage: dateFromCalendarPage }))).then(() => updateTaskList() & closeContext(contextData.taskId))}>
                <DublicateIcon style={fromRemoved && { fill: '#A4A8B1' }} className="dublicateIcon" />
                <p className="contextMenu__item__description">Дублировать задачу</p>
              </li>
            }
            <li className="contextMenu__second-item"
              style={fromRemoved && { cursor: 'default', pointerEvents: 'none', color: '#A4A8B1' }}
              onClick={() => task.isRepit ? setIsDeleteTask(!isDeleteTask) : removeHandler()}>
              {/* onClick={() => dispatch(removeTodo({ id: contextData.taskId, dateFromCalendarPage: dateFromCalendarPage })).then(() => updateTaskList() & closeContext(contextData.taskId))}> */}

              <RemoveIcon style={fromRemoved && { fill: '#A4A8B1' }} className="removeIcon" />
              <p className="contextMenu__item__description">Удалить</p>
            </li>
          </ul>
        </ul>
      </nav>
    </div>
  )
}

export default ContextMenuTask;